const dataClients = [
    { id: 1, src: "/assets/clientes/Angloamerican.png", alt: "Angloamerican" },
    { id: 2, src: "/assets/clientes/Antamina.png", alt: "Antamina" },
    { id: 3, src: "/assets/clientes/Antapaccay.png", alt: "Antapaccay" },
    { id: 4, src: "/assets/clientes/Buenaventura.png", alt: "Buenaventura" },
    { id: 5, src: "/assets/clientes/CEIM.png", alt: "CEIM" },
    { id: 6, src: "/assets/clientes/cerroverde.png", alt: "Cerro Verde" },
    { id: 7, src: "/assets/clientes/Confipetrol.png", alt: "Confipetrol" },
    { id: 8, src: "/assets/clientes/Draguer.png", alt: "Draguer" },
    { id: 9, src: "/assets/clientes/Electro-sur.png", alt: "Electro-sur" },
    { id: 10, src: "/assets/clientes/Electrosur.png", alt: "Electrosur" },
    { id: 11, src: "/assets/clientes/Enel.png", alt: "Enel" },
    { id: 12, src: "/assets/clientes/Ferreyos.png", alt: "Ferreyos" },
    { id: 13, src: "/assets/clientes/first-quantum.png", alt: "First Quantum" },
    { id: 14, src: "/assets/clientes/IncaTops.png", alt: "Inca Tops" },
    { id: 15, src: "/assets/clientes/ISEM.png", alt: "ISEM" },
    { id: 16, src: "/assets/clientes/ITP.png", alt: "ITP" },
    { id: 17, src: "/assets/clientes/LasBambas.png", alt: "Las Bambas" },
    { id: 18, src: "/assets/clientes/link-miners.png", alt: "Link Miners" },
    { id: 19, src: "/assets/clientes/ntt-data.png", alt: "NTT Data" },
    { id: 20, src: "/assets/clientes/peñoles.png", alt: "Peñoles" },
    { id: 21, src: "/assets/clientes/Rimac.png", alt: "Rimac" },
    { id: 22, src: "/assets/clientes/Senati.png", alt: "Senati" },
    { id: 23, src: "/assets/clientes/Seprocal.png", alt: "Seprocal" },
    { id: 24, src: "/assets/clientes/Siderperu.png", alt: "Siderperu" },
    { id: 25, src: "/assets/clientes/sodexo.png", alt: "Sodexo" },
    { id: 26, src: "/assets/clientes/southern.png", alt: "Southern" },
    { id: 27, src: "/assets/clientes/Tecsup.png", alt: "Tecsup" },
    { id: 28, src: "/assets/clientes/textialpaca.png", alt: "Textialpaca" },
    { id: 29, src: "/assets/clientes/Tisur.png", alt: "Tisur" },
    { id: 30, src: "/assets/clientes/Unsa.png", alt: "Unsa" },
    { id: 31, src: "/assets/clientes/Volcan.png", alt: "Volcan" },
    { id: 32, src: "/assets/clientes/volvo.png", alt: "Volvo" },
];

const dataPartners = [
    { id: 1, src: "/assets/cerv/about/socios/01-innovacionmineradelperu.png", alt: "Innovacion Minera del Peru" },
    { id: 2, src: "/assets/cerv/about/socios/02-proinnovate.png", alt: "Proinnovate" },
    { id: 3, src: "/assets/cerv/about/socios/03-asterpormagical.png", alt: "Aster por Magical" },
    { id: 4, src: "/assets/cerv/about/socios/04-camaradecomercio.png", alt: "Camara de Comercio" },
    { id: 5, src: "/assets/cerv/about/socios/05-meta.png", alt: "Meta" },
    { id: 6, src: "/assets/cerv/about/socios/concytec.png", alt: "Concytec" },
    { id: 7, src: "/assets/cerv/about/socios/innovate.png", alt: "Innovate" },
    { id: 8, src: "/assets/cerv/about/socios/koica.jpg", alt: "Koica" },
    { id: 9, src: "/assets/cerv/about/socios/promperu.png", alt: "Promperu" },
];

export { dataClients, dataPartners };